export default "__VITE_ASSET__ce8fb927__"